module.exports = __webpack_public_path__ + "img/choose4.a8914d0a.png";